import React, { CSSProperties } from "react";
import { IconData } from "lib/api";
import { Icon } from "components/common";
import useStyles from "./styles";

interface IconColumnCellProps {
  icon?: IconData;
  children?: React.ReactNode;
  style?: CSSProperties;
}

// due to spacing calculation and to display the overflow tooltip correctly,
// please make sure you have padding 0 in the column
const IconColumnCell: React.FC<IconColumnCellProps> = ({
  icon,
  children,
  style,
}) => {
  const classes = useStyles();
  return (
    <>
      <div
        className={classes.incidentNameIcon}
        style={{ ...style, backgroundColor: icon?.color || "#C62828" }}
      >
        {icon?.icon_type && icon.icon_type !== "none" && (
          <Icon
            iconData={icon}
            {...(icon &&
              icon?.icon_type === "fontawesome" && {
                color: "#FBFCFC",
              })}
          />
        )}
      </div>
      {children}
    </>
  );
};

export default IconColumnCell;
